import React from 'react';
import './ToggleSwitch.css';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  labels?: {
    on: string;
    off: string;
  };
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  size = 'medium',
  labels = { on: 'Oui', off: 'Non' }
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div className={`toggle-switch ${size} ${disabled ? 'disabled' : ''}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={handleToggle}
        disabled={disabled}
        className="toggle-input"
        id="toggle-switch"
      />
      <label htmlFor="toggle-switch" className="toggle-label">
        <span className="toggle-slider">
          <span className="toggle-text">
            {checked ? labels.on : labels.off}
          </span>
        </span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
